// Same FeatBit evaluation server for every environment, so it is not configured per env.
export const FEATBIT_SERVER_URI = "https://app-eval.featbit.co";

export const FEATURE_FLAGS = {
  DOC_SCAN_FOR_FARMERS: "doc-scan-for-farmers",
  SOIL_SIGHT_INTEGRATION: "soil-sight-integration",
  SOIL_SIGHT_SKIP_ACQUISITION_FLOW: "soil-sight-skip-acquisition-flow",
  SOIL_SIGHT_CM_BREAKDOWN: "soil-sight-cm-breakdown",
  ORGANIC_FERTILIZER_SOURCES: "organic-fertilizer-sources",
  FIELD_MANAGEMENT_VIEW_SWITCHER: "field-management-view-switcher",
  COPILOT: "copilot",
  COVER_CROP_DETECTION: "cover-crop-detection",
  BULK_EDITING_IMPROVEMENTS: "bulk-editing-improvements",
  GLOBAL_FARM_SWITCH: "global-farm-switch",
  SOIL_SIGHT_COVER_CROP_FIT_WARNING: "soil-sight-cover-crop-fit-warning",
  NEW_HOMEPAGE_HERO: "new-homepage-hero",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
